import { cx } from "@suse-o11y/class-variance";
import { Slot, type Slottable } from "@suse-o11y/slot";
import React from "react";

import styles from "./_tag.module.css";

/**
 * Check out Figma for the design of the tag:
 *
 * @link https://www.figma.com/design/YIkZms7ygvgqXYnbzDFr8Y/--StackState-DS?node-id=3905-427&m=dev
 */

export interface TagProps extends Slottable, React.ComponentProps<"button"> {
	/**
	 * @default false
	 */
	selected?: boolean;
}

export const Tag = React.forwardRef<React.ElementRef<"button">, TagProps>(
	({ asChild = false, selected = false, disabled = false, className, ...props }, ref) => {
		const Root = asChild ? Slot : "button";

		return (
			<Root
				aria-disabled={disabled}
				aria-selected={selected}
				className={cx(styles.tag, className)}
				disabled={disabled}
				ref={ref}
				type={Root === "button" ? "button" : undefined}
				{...props}
			/>
		);
	},
);

if (import.meta.env.DEV) {
	Tag.displayName = "Tag";
}
